import _ from 'lodash';
import {
  FETCHING_STORYBOARD_LEAD_SUMMARY, FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED, FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED,
  FETCHING_STORYBOARD_LEAD_DETAILS, FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED, FETCHING_STORYBOARD_LEAD_DETAILS_FAILED,
  FETCHING_FIRST_CAPTURED_LEAD_DETAILS, FETCHING_FIRST_CAPTURED_LEAD_DETAILS_SUCCEEDED, FETCHING_FIRST_CAPTURED_LEAD_DETAILS_FAILED,
  FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS, FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED, FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED,
  FETCHING_STORYBOARD_LEAD_JOURNEY, FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED, FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED,
  FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD, FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION, FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED,
  FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD, FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION, FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED,
  FETCHING_ASSET_INTERACTION_FOR_LEAD, FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED, FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED,
  FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD, FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED, INVALIDATE_LEADS_DOWNLOAD_DATA,
  FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION, FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED, FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED, FETCHING_STORYBOARD_SUCCEEDED,
  INVALIDATE_STORYBOARD_LEAD_DETAILS
} from 'constants/actionTypes';

const initialState = {
  storyboard: null,
  summary: {
    loading: false,
    invalidated: true,
    visitor: {},
    items:{},
    error: null,
  },
  firstCaptured: {
    loading: false,
    items: {},
    invalidated: true,
    error: null
  },
  latestCampaign: {
    loading: false,
    items: {},
    invalidated: true,
    error: null
  },
  journey: {
    loading: false,
    items: [],
    invalidated: true,
    pagination: {},
    error: null
  },
  pagesInteractions: {
    loading: false,
    invalidated: true,
    pagination: {},
    items: [],
    chartItems: [],
    error: null
  },
  assetInteractions: {
    loading: false,
    invalidated: true,
    pagination: {},
    items: [],
    chartItems: [],
    error: null
  },
  downloads: {
    loading: false,
    invalidated: false,
    items: []
  }
}

export function leadsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_STORYBOARD_LEAD_DETAILS: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          invalidated: true,
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_DETAILS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          invalidated: false,
          visitor: response
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_DETAILS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_SUMMARY: {
      const { id } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          invalidated: true,
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_SUMMARY_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          invalidated: false,
          items: response
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_SUMMARY_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_FIRST_CAPTURED_LEAD_DETAILS: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        firstCaptured: {
          ...state.firstCaptured,
          loading: true,
        }
      }
    }

    case FETCHING_FIRST_CAPTURED_LEAD_DETAILS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        firstCaptured: {
          ...state.firstCaptured,
          loading: false,
          items: response
        }
      }
    }

    case FETCHING_FIRST_CAPTURED_LEAD_DETAILS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        firstCaptured: {
          ...state.firstCaptured,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: true,
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: false,
          items: response
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: true,
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: false,
          items: response
        }
      }
    }

    case FETCHING_LATEST_CAMPAIGN_LEAD_DETAILS_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        latestCampaign: {
          ...state.latestCampaign,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_JOURNEY: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        journey: {
          ...state.journey,
          loading: true,
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_JOURNEY_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        journey: {
          ...state.journey,
          loading: false,
          items: [
            ...state.journey.items,
            ...response.records
          ],
          pagination: {
            currentPage: response.currentPage,
            recordsPerPage: response.recordsPerPage,
            totalPages: response.totalPages,
            totalRecordsCount: response.totalRecordsCount
          },
        }
      }
    }

    case FETCHING_STORYBOARD_LEAD_JOURNEY_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        journey: {
          ...state.journey,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          invalidated: false,
          items: response.records,
          pagination: {
            ...state.pagination,
            current: response.currentPage,
            totalPages: response.totalPages,
            totalRecordsCount: response.totalRecordsCount
          }
        }
      }
    }

    case FETCHING_INTERACTIVE_PAGE_INTERACTION_FOR_LEAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          invalidated: false,
          chartItems: response.records,
        }
      }
    }

    case FETCHING_CHARTS_FOR_INTERACTIVE_PAGE_LEAD_INTERACTION_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          invalidated: false,
          items: response.records,
          pagination: {
            ...state.pagination,
            current: response.currentPage,
            totalPages: response.totalPages,
            totalRecordsCount: response.totalRecordsCount
          }
        }
      }
    }

    case FETCHING_LANDING_PAGE_INTERACTION_FOR_LEAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          invalidated: false,
          chartItems: response.records,
        }
      }
    }

    case FETCHING_CHARTS_FOR_LANDING_PAGE_LEAD_INTERACTION_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_ASSET_INTERACTION_FOR_LEAD: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_ASSET_INTERACTION_FOR_LEAD_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: false,
          invalidated: false,
          items: response.records,
          pagination: {
            ...state.pagination,
            current: response.currentPage,
            totalPages: response.totalPages,
            totalRecordsCount: response.totalRecordsCount
          }
        }
      }
    }

    case FETCHING_ASSET_INTERACTION_FOR_LEAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION: {
      const { id, request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: true,
        }
      }
    }

    case FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_SUCCEEDED: {
      const { id, response } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      const assetInteractionAnalytics = response.records.map((data, index)=>{
        const asset = _.get(data, 'asset.content.asset');
        return {
          ...data,
          name: asset.name
        }
      })

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: false,
          invalidated: false,
          chartItems: assetInteractionAnalytics,
        }
      }
    }

    case FETCHING_CHARTS_FOR_ASSET_LEAD_INTERACTION_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        assetInteractions: {
          ...state.assetInteractions,
          loading: false,
          error: error
        }
      }
    }

    case FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD: {
      const { request } = action.payload;

      if (request.storyboard !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        downloads: {
          ...state.downloads,
          loading: true,
          progress: true,
          completed: false
        }
      }
    }

    case FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED: {
      const { id, response } = action.payload;
      var completed = false;
      var progress = true;

      const hasMoreItems = response.currentPage < response.totalPages - 1;

      if (!hasMoreItems) {
        completed = true;
        progress = false;
      }

      if (id !== state.storyboard) {
        return state;
      }

      var items = [...state.downloads.items, ...response.records]

      return {
        ...state,
        downloads: {
          ...state.downloads,
          loading: false,
          items: items,
          pagination: {
            ...state.pagination,
            current: response.currentPage,
            totalPages: response.totalPages,
            totalRecordsCount: response.totalRecordsCount,
            hasMore: response.currentPage < (response.totalRecordsCount)
          },
          completed: completed,
          progress: progress,
        }
      }
    }

    case FETCHING_LEADS_REPORTS_DATA_FOR_DOWNLOAD_FAILED: {
      const { id, error } = action.payload;

      if (id !== state.storyboard) {
        return state;
      }

      return {
        ...state,
        downloads: {
          ...state.downloads,
          loading: false,
          completed: false,
          progress: false,
          error: error
        }
      }
    }

    case FETCHING_STORYBOARD_SUCCEEDED:{
      const response = action.payload;

      return {
        ...state,
        storyboard: response.id
      }
    }

    case INVALIDATE_LEADS_DOWNLOAD_DATA: {
      return {
        ...state,
        downloads: {
          loading: false,
          invalidated: true,
          pagination: {
            current: -1,
            totalPages: 1,
            hasMore: false
          },
          completed: false,
          progress: false,
          items: []
        }
      }
    }

    case INVALIDATE_STORYBOARD_LEAD_DETAILS: {

      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          invalidated: true,
          visitor: {},
        },
        firstCaptured: {
          ...state.firstCaptured,
          invalidated: true,
          loading: false,
          items: {},
        },
        latestCampaign: {
          ...state.latestCampaign,
          loading: false,
          items: {},
          invalidated: true,
        },
        journey: {
          ...state.journey,
          invalidated: true,
          loading: false,
          items: [],
          pagination: {},
        },
        pagesInteractions: {
          ...state.pagesInteractions,
          loading: false,
          invalidated: true,
          pagination: {},
          items: [],
          chartItems: [],
        },
        assetInteractions: {
          ...state.assetInteractions,
          loading: false,
          invalidated: true,
          pagination: {},
          items: [],
          chartItems: [],
        }
      }
    }

    default:
      return state;
  }
}